import { Flex, Typography } from "@jewlr/storybook/core"
import React from "react"
import { useSelector } from "react-redux"
import scroll from "scroll"
import scrollDoc from "scroll-doc"
import styled from "styled-components"

import { openModal } from "components/modal"
import { jewlr_t, IS_CA } from "helpers/application"

const Ribbon = styled(Flex).attrs((props) => ({
  alignItems: "center",
  bg: "aquamarine",
  color: "blackPrint",
  justifyContent: "center",
  px: 1,
  py: "4px",
  ...props,
}))``

const ShippingRibbon = () => {
  const ship = useSelector((state) => state.wizard.shipping.main)
  // const holidayDelivery = useSelector(
  //   (state) => state.wizard.shipping.main?.available_holiday_delivery
  // )

  if (!ship) return null

  let date = null

  if (ship.delivery_dates && ship.delivery_dates.length > 0) {
    date = `${ship.delivery_dates[0].date}`
  }

  if (!date) return null

  const scrollToShipping = (e) => {
    e.preventDefault()
    if (IS_CA() && ship.delivery_dates?.length > 0) {
      // Open Enter Postal Code modal (Canada)
      openModal("#shipping-info")
    } else {
      const page = scrollDoc()
      // If delivery dates are available, scroll to Shipping Options section
      const yOffset =
        document.getElementById("shipping_options_container").offsetTop - 300
      scroll.top(page, yOffset)
    }
  }

  // // Holiday availability messaging
  // // ship.view_type === "NEED_POSTAL_CODE" ||
  // // ship.view_type === "INVENTORY_UNAVAILABLE"
  // if (holidayDelivery) {
  //   msg = `Arrives before ${
  //     sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday
  //   }`
  //   // dateMsg = ""
  //   // } else if (false && holidayDelivery) {
  //   //   msg = `Delivers before ${sl.config.guaranteed_holiday}!`
  //   //   dateMsg = ""
  // }

  return (
    <Ribbon onClick={scrollToShipping}>
      <Typography fontSize="12px" fontWeight="600">
        FREE {jewlr_t("terms.shipping").toUpperCase()} &ndash; Arrives by {date}
      </Typography>
    </Ribbon>
  )
}

export default ShippingRibbon
